<template>
  <button
    type="button"
    class="outline-none"
    @click="navigateToHomePage"
  >
    <VeridisLogo />
  </button>
</template>

<script>
export default {
  name: 'LogoHomeButton',

  methods: {
    navigateToHomePage() {
      const protocol
        = process.env.NODE_ENV === 'development' ? 'http' : 'https'
      window.location.href = `${protocol}://${this.$config.public.fullyQualifiedDomain}`
    },
  },
}
</script>
